export const getGoogleAuthRedirectUrl = ({ location }: Window): string => `${location.origin}/login`;
